import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter, ChangeDetectorRef } from "@angular/core";
import { formatNumber } from '@angular/common';
import { SharedService, round, roundUp, large } from '../../../shared'
import { Titrationsplan, PartnerNamesEnum } from '../../shared';
import { Options } from 'ngx-slider-v2';

import * as d3 from "d3";

const DE = 'de';

@Component({
    selector: 'titrationsplan-popup',
    templateUrl: "./titrationsplan-popup.component.html",
    styleUrls: ["./titrationsplan-popup.component.scss"],
    encapsulation: ViewEncapsulation.None
})
export class TitrationsplanPpopupComponent implements OnInit {
    @Input() partnerName: string = "";
    @Input() titrationsplan: Titrationsplan;
    @Output() onSelectValues = new EventEmitter<any>();

    PartnerNamesEnum = PartnerNamesEnum;

    dronabinolSorteList: any[] = [];
    zieltagesdosisList: any[] = [];
    startTagesdosisList: any[] = [];
    anzahlDerTageList: any[] = [];

    presetButtonsList: any[] = [
        {
            id: 1,
            title: 'Gleichmäßige Verteilung',
            value: '25% - 25% - 25% - 25%'
        },
        {
            id: 2,
            title: 'Nachts',
            value: '12.5% - 12.5% - 25% - 50%'
        },
        {
            id: 3,
            title: 'Vormittags',
            value: '40% - 20% - 20% - 20%'
        },
        {
            id: 4,
            title: 'Nachmittags',
            value: '20% - 40% - 20% - 20%'
        }
    ];
    selectedPresetButton: any = null;

    dronabinolSorte: any = "25 mg/mL";
    zieltagesdosis: any = 15;
    startTagesdosis: any = 2.5;
    anzahlDerTage: any = 14;
    morgensVal: number = 5;
    mittagsVal: number = 5;
    abendsVal: number = 10;
    zurNachtVal: number = 0;


    dosierungsSchemaOptions: Options = {
        floor: 0,
        ceil: 10,
        step: 1,
        vertical: true,
        autoHideLimitLabels: true,
        hideLimitLabels: true,
        hidePointerLabels: true,
        showSelectionBar: true,
        getSelectionBarColor: (value: number): string => {
            return "#1D90F6";
        },
        getPointerColor: (value: number): string => {
            if (value > 0) {
                return "#1D90F6";
            }
            return "#FFFFFF";
        },
    }

    totalDaysForCalc = 30;
    milligrammCalculation: any[] = [];
    tropfenCalculation: any[] = [];
    hubeCalculation: any[] = [];


    tropfenformData: any[] = [];
    hubdosierungData: any[] = [];

    showTropfen: boolean = false;
    showHube: boolean = true;
    showWeitereInfo: boolean = false;

    oneTropfen = 0.05;
    twentyTropfen = 20;
    oneHub = 30;

    kosten = 500;
    kostenEuroPmg = 359;

    dronabinolSorteListCalc: any[] = [
        { label: '10 mg/mL', value: 10, type: 'Dronabinol' },
        { label: '25 mg/mL', value: 25, type: 'Dronabinol' },
        { label: '50 mg/mL', value: 50, type: 'Dronabinol' },
        { label: '5/10 od. 5/20', value: 5, type: 'Cannabisextrakt' },
        { label: '10/10', value: 10, type: 'Cannabisextrakt' },
        { label: '12,5/12,5', value: 12.5, type: 'Cannabisextrakt' },
        { label: '20/1 od. 20/20', value: 20, type: 'Cannabisextrakt' },
        { label: '25/1 od. 25/25', value: 25, type: 'Cannabisextrakt' },
        { label: '30/0', value: 30, type: 'Cannabisextrakt' },
        { label: '50/0', value: 50, type: 'Cannabisextrakt' }
    ];

    zieltagesdosisListCalc: any[] = [
        { label: '2,5 mg/Tag', value: 2.5 },
        { label: '5 mg/Tag', value: 5 },
        { label: '7,5 mg/Tag', value: 7.5 },
        { label: '10 mg/Tag', value: 10 },
        { label: '12,5 mg/Tag', value: 12.5 },
        { label: '15 mg/Tag', value: 15 },
        { label: '17,5 mg/Tag', value: 17.5 },
        { label: '20 mg/Tag', value: 20 },
        { label: '25 mg/Tag', value: 25 },
        { label: '30 mg/Tag', value: 30 },
        { label: '35 mg/Tag', value: 35 },
        { label: '40 mg/Tag', value: 40 },
        { label: '45 mg/Tag', value: 45 },
        { label: '50 mg/Tag', value: 50 }
    ];

    startTagesdosisListCalc: any[] = [
        { label: '1 mg', value: 1 },
        { label: '2 mg', value: 2 },
        { label: '2,5 mg', value: 2.5 },
        { label: '3 mg', value: 3 },
        { label: '4 mg', value: 4 },
        { label: '5 mg', value: 5 },
        { label: '6,25 mg', value: 6.25 },
        { label: '7,5 mg', value: 7.5 },
        { label: '10 mg', value: 10 }
    ];

    get isPartnerPage() {
        return this.partnerName && this.partnerName.length;
    }

    get jsPanelContentHeight() {
        if (document.getElementsByClassName("jsPanel-content").length) {
            return document.getElementsByClassName("jsPanel-content")[0].clientHeight;
        }
        else {
            return document.body.clientHeight;
        }
    }

    get jsPanelContentWidth() {
        if (document.getElementsByClassName("jsPanel-content").length) {
            return document.getElementsByClassName("jsPanel-content")[0].clientWidth;
        }
        else {
            return document.body.clientWidth;
        }
    }

    get printableHTML() {
        return document.getElementById("popup-form-table-diagram").outerHTML;
    }

    get dronabinolSorteVal() {
        if (this.dronabinolSorte) {
            let obj = this.dronabinolSorteListCalc.find(a => a.label === this.dronabinolSorte);
            if (obj) {
                return obj.value;
            }
        }
        return 1;
    }
    get dronabinolSorteType() {
        if (this.dronabinolSorte) {
            let obj = this.dronabinolSorteListCalc.find(a => a.label === this.dronabinolSorte);
            if (obj) {
                return obj.type;
            }
        }
        return "";
    }

    get thcMGTropfen() {
        return this.dronabinolSorteVal / this.twentyTropfen;
    }


    get thcMGHub() {
        return this.dronabinolSorteVal / this.oneHub;
    }

    get zieltagesdosisVal() {
        return parseFloat(this.zieltagesdosis.toString());
    }

    get zieltagesdosisLabel() {
        if (this.zieltagesdosis) {
            let obj = this.zieltagesdosisListCalc.find(a => a.value === this.zieltagesdosisVal);
            if (obj) {
                return obj.label;
            }
        }
        return "";
    }

    get startTagesdosisVal() {
        return parseFloat(this.startTagesdosis.toString());
    }

    get startTagesdosisLabel() {
        if (this.zieltagesdosis) {
            let obj = this.startTagesdosisListCalc.find(a => a.value === this.startTagesdosisVal);
            if (obj) {
                return obj.label;
            }
        }
        return "";
    }

    get anzahlDerTageVal() {
        return parseFloat(this.anzahlDerTage.toString());
    }

    get anwendungenProTagVal() {
        var total = 0;
        if (this.morgensVal > 0) {
            total += 1;
        }
        if (this.mittagsVal > 0) {
            total += 1;
        }
        if (this.abendsVal > 0) {
            total += 1;
        }
        if (this.zurNachtVal > 0) {
            total += 1;
        }
        return total;
    }

    get totalDosierungsVal() {
        return this.morgensVal + this.mittagsVal + this.abendsVal + this.zurNachtVal;
    }

    get morgensPer() {
        var per = round((this.morgensVal / this.totalDosierungsVal) * 100, 2) || 0;
        return per;
    }

    get mittagsPer() {
        var per = round((this.mittagsVal / this.totalDosierungsVal) * 100, 2) || 0;
        return per;
    }

    get abendsPer() {
        var per = round((this.abendsVal / this.totalDosierungsVal) * 100, 2) || 0;
        return per;
    }

    get zurNachtPer() {
        var per = round((this.zurNachtVal / this.totalDosierungsVal) * 100, 2) || 0;
        return per;
    }

    get StufeIntervallOneAnzahlTage() {
        var val = 0;
        if (this.anwendungenProTagVal == 1) {
            val = this.anzahlDerTageVal;
        } else {
            val = 2;
        }
        return { key: 1, val, calc: val };
    }

    get StufeIntervallTwoAnzahlTage() {
        var val = 0;
        if (this.anwendungenProTagVal == 1) {
            val = 0;
        } else if (this.anwendungenProTagVal == 2) {
            val = this.anzahlDerTageVal - this.StufeIntervallOneAnzahlTage.val;
        } else {
            val = round((this.anzahlDerTageVal - this.StufeIntervallOneAnzahlTage.val) / (this.anwendungenProTagVal - 1));
        }
        return { key: 2, val, calc: val + this.StufeIntervallOneAnzahlTage.calc };
    }

    get StufeIntervallThreeAnzahlTage() {
        var val = 0;
        if (this.anwendungenProTagVal < 3) {
            val = 0;
        } else {
            if (this.anwendungenProTagVal == 3) {
                val = this.anzahlDerTageVal - (this.StufeIntervallOneAnzahlTage.val + this.StufeIntervallTwoAnzahlTage.val);
            } else if (this.anwendungenProTagVal == 4) {
                val = round((this.anzahlDerTageVal - this.StufeIntervallOneAnzahlTage.val) / (this.anwendungenProTagVal - 1));
            } else {
                val = 0;
            }
        }
        return { key: 3, val, calc: val + this.StufeIntervallTwoAnzahlTage.calc };
    }

    get StufeIntervallFourAnzahlTage() {
        var val = 0;
        if (this.anwendungenProTagVal < 4) {
            val = 0;
        } else {
            val = this.anzahlDerTageVal - (this.StufeIntervallThreeAnzahlTage.calc);
        }
        return { key: 4, val, calc: val };
    }

    get DisplayTropfenHuben() {
        if (this.tropfenCalculation.length && this.hubeCalculation.length) {
            let trofenObj = this.tropfenCalculation[0];
            let hubeObj = this.hubeCalculation[0];
            return `${round(trofenObj.abends * this.thcMGTropfen, 1)} mg/${round(trofenObj.abends * this.oneTropfen, 2)} mL (${trofenObj.abends} Tropfen oder ${hubeObj.abends} Hüben)`
        }
        return "";
    }

    get kostenCalc() {
        return this.kostenEuroPmg / this.kosten;
    }

    get zeitlichesWirkungsprofil() {
        var obj: any = {
            morgensVal: this.morgensVal + 0.000001,
            mittagsVal: this.mittagsVal - 0.00001,
            abendsVal: this.abendsVal + 0.0002,
            zurNachtVal: this.zurNachtVal - 0.0000001
        }
        var total = obj.morgensVal + obj.mittagsVal + obj.abendsVal + obj.zurNachtVal;
        obj = {
            ...obj,
            morgensPer: (obj.morgensVal / total) * 100 || 0,
            morgensPerR: round((obj.morgensVal / total) * 100, 2) || 0,
            mittagsPer: (obj.mittagsVal / total) * 100 || 0,
            mittagsPerR: round((obj.mittagsVal / total) * 100, 2) || 0,
            abendsPer: (obj.abendsVal / total) * 100 || 0,
            abendsPerR: round((obj.abendsVal / total) * 100, 2) || 0,
            zurNachtPer: (obj.zurNachtVal / total) * 100 || 0,
            zurNachtPerR: round((obj.zurNachtVal / total) * 100, 2) || 0,
            total
        }
        return obj;
    }

    get zeitlicherSchwerpunkt() {
        var objWirk = this.zeitlichesWirkungsprofil;

        var an1MoVal = (this.morgensVal / objWirk.total) > 0.25 ? 1 : 0;
        var an1MiVal = (this.mittagsVal / objWirk.total) > 0.25 ? 1 : 0;
        var an1AbVal = (this.abendsVal / objWirk.total) > 0.25 ? 1 : 0;
        var an1ZNVal = (this.zurNachtVal / objWirk.total) > 0.25 ? 1 : 0;
        var an1Total = an1MoVal + an1MiVal + an1AbVal + an1ZNVal;

        var anwendungen = {
            one: {
                morgensVal: an1MoVal,
                morgensPer: ((an1MoVal / an1Total) * 100) || 0,
                morgensPerR: round((an1MoVal / an1Total) * 100) || 0,
                mittagsVal: an1MiVal,
                mittagsPer: ((an1MiVal / an1Total) * 100) || 0,
                mittagsPerR: round((an1MiVal / an1Total) * 100) || 0,
                abendsVal: an1AbVal,
                abendsPer: ((an1AbVal / an1Total) * 100) || 0,
                abendsPerR: round((an1AbVal / an1Total) * 100) || 0,
                zurNachtVal: an1ZNVal,
                zurNachtPer: ((an1ZNVal / an1Total) * 100) || 0,
                zurNachtPerR: round((an1ZNVal / an1Total) * 100) || 0,
            },
            two: {
                morgensVal: this.morgensVal,
                morgensPer: ((this.morgensVal / this.totalDosierungsVal) * 100) || 0,
                morgensPerR: round((this.morgensVal / this.totalDosierungsVal) * 100) || 0,
                mittagsVal: this.mittagsVal,
                mittagsPer: ((this.mittagsVal / this.totalDosierungsVal) * 100) || 0,
                mittagsPerR: round((this.mittagsVal / this.totalDosierungsVal) * 100) || 0,
                abendsVal: this.abendsVal,
                abendsPer: ((this.abendsVal / this.totalDosierungsVal) * 100) || 0,
                abendsPerR: round((this.abendsVal / this.totalDosierungsVal) * 100) || 0,
                zurNachtVal: this.zurNachtVal,
                zurNachtPer: ((this.zurNachtVal / this.totalDosierungsVal) * 100) || 0,
                zurNachtPerR: round((this.zurNachtVal / this.totalDosierungsVal) * 100) || 0,
            },
            three: {
                morgensVal: this.morgensVal,
                morgensPer: ((this.morgensVal / this.totalDosierungsVal) * 100) || 0,
                morgensPerR: round((this.morgensVal / this.totalDosierungsVal) * 100) || 0,
                mittagsVal: this.mittagsVal,
                mittagsPer: ((this.mittagsVal / this.totalDosierungsVal) * 100) || 0,
                mittagsPerR: round((this.mittagsVal / this.totalDosierungsVal) * 100) || 0,
                abendsVal: this.abendsVal,
                abendsPer: ((this.abendsVal / this.totalDosierungsVal) * 100) || 0,
                abendsPerR: round((this.abendsVal / this.totalDosierungsVal) * 100) || 0,
                zurNachtVal: this.zurNachtVal,
                zurNachtPer: ((this.zurNachtVal / this.totalDosierungsVal) * 100) || 0,
                zurNachtPerR: round((this.zurNachtVal / this.totalDosierungsVal) * 100) || 0,
            },
            four: {
                morgensVal: this.morgensVal,
                morgensPer: ((this.morgensVal / this.totalDosierungsVal) * 100) || 0,
                morgensPerR: round((this.morgensVal / this.totalDosierungsVal) * 100) || 0,
                mittagsVal: this.mittagsVal,
                mittagsPer: ((this.mittagsVal / this.totalDosierungsVal) * 100) || 0,
                mittagsPerR: round((this.mittagsVal / this.totalDosierungsVal) * 100) || 0,
                abendsVal: this.abendsVal,
                abendsPer: ((this.abendsVal / this.totalDosierungsVal) * 100) || 0,
                abendsPerR: round((this.abendsVal / this.totalDosierungsVal) * 100) || 0,
                zurNachtVal: this.zurNachtVal,
                zurNachtPer: ((this.zurNachtVal / this.totalDosierungsVal) * 100) || 0,
                zurNachtPerR: round((this.zurNachtVal / this.totalDosierungsVal) * 100) || 0,
            }
        };

        var maxPer = Math.max(objWirk.morgensPer, objWirk.mittagsPer, objWirk.abendsPer, objWirk.zurNachtPer);
        var s1LargePer = large([objWirk.morgensPer, objWirk.mittagsPer, objWirk.abendsPer, objWirk.zurNachtPer], 2);
        var s2LargePer = large([objWirk.morgensPer, objWirk.mittagsPer, objWirk.abendsPer, objWirk.zurNachtPer], 3);
        var s3LargePer = large([objWirk.morgensPer, objWirk.mittagsPer, objWirk.abendsPer, objWirk.zurNachtPer], 4);

        var s1MoVal = (maxPer == s1LargePer) ? 0 : (objWirk.morgensPer == maxPer) ? 1 : 0;
        var s1MiVal = (maxPer == s1LargePer) ? 0 : (objWirk.mittagsPer == maxPer) ? 1 : 0;
        var s1AbVal = (maxPer == s1LargePer) ? 0 : (objWirk.abendsPer == maxPer) ? 1 : 0;
        var s1ZUVal = (maxPer == s1LargePer) ? 0 : (objWirk.zurNachtPer == maxPer) ? 1 : 0;
        var s1Total = s1MoVal + s1MiVal + s1AbVal + s1ZUVal;

        var s2MoVal = (this.anwendungenProTagVal == 1) ? s1MoVal : (this.anwendungenProTagVal > 1) ? (objWirk.morgensPer > s2LargePer ? 1 * objWirk.morgensPer / 100 : 0) : 0;
        var s2MiVal = (this.anwendungenProTagVal == 1) ? s1MiVal : (this.anwendungenProTagVal > 1) ? (objWirk.mittagsPer > s2LargePer ? 1 * objWirk.mittagsPer / 100 : 0) : 0;
        var s2AbVal = (this.anwendungenProTagVal == 1) ? s1AbVal : (this.anwendungenProTagVal > 1) ? (objWirk.abendsPer > s2LargePer ? 1 * objWirk.abendsPer / 100 : 0) : 0;
        var s2ZUVal = (this.anwendungenProTagVal == 1) ? s1ZUVal : (this.anwendungenProTagVal > 1) ? (objWirk.zurNachtPer > s2LargePer ? 1 * objWirk.zurNachtPer / 100 : 0) : 0;
        var s2Total = s2MoVal + s2MiVal + s2AbVal + s2ZUVal;

        var s3MoVal = (this.anwendungenProTagVal == 1) ? s1MoVal : (this.anwendungenProTagVal == 2) ? s2MoVal : (this.anwendungenProTagVal > 2) ? (objWirk.morgensPer > s3LargePer ? 1 * objWirk.morgensPer / 100 : 0) : 0;
        var s3MiVal = (this.anwendungenProTagVal == 1) ? s1MiVal : (this.anwendungenProTagVal == 2) ? s2MiVal : (this.anwendungenProTagVal > 2) ? (objWirk.mittagsPer > s3LargePer ? 1 * objWirk.mittagsPer / 100 : 0) : 0;
        var s3AbVal = (this.anwendungenProTagVal == 1) ? s1AbVal : (this.anwendungenProTagVal == 2) ? s2AbVal : (this.anwendungenProTagVal > 2) ? (objWirk.abendsPer > s3LargePer ? 1 * objWirk.abendsPer / 100 : 0) : 0;
        var s3ZUVal = (this.anwendungenProTagVal == 1) ? s1ZUVal : (this.anwendungenProTagVal == 2) ? s2ZUVal : (this.anwendungenProTagVal > 2) ? (objWirk.zurNachtPer > s3LargePer ? 1 * objWirk.zurNachtPer / 100 : 0) : 0;
        var s3Total = s3MoVal + s3MiVal + s3AbVal + s3ZUVal;

        var stufe = {
            morgensVal: round(objWirk.morgensVal - round(objWirk.total / 4)),
            mittagsVal: round(objWirk.mittagsVal - round(objWirk.total / 4)),
            abendsVal: round(objWirk.abendsVal - round(objWirk.total / 4)),
            zurNachtVal: round(objWirk.zurNachtVal - round(objWirk.total / 4)),
            one: {
                morgensVal: round(s1MoVal, 2),
                morgensPer: ((s1MoVal / s1Total) * 100) || 0,
                morgensPerR: round((s1MoVal / s1Total) * 100) || 0,
                mittagsVal: round(s1MiVal, 2),
                mittagsPer: ((s1MiVal / s1Total) * 100) || 0,
                mittagsPerR: round((s1MiVal / s1Total) * 100) || 0,
                abendsVal: round(s1AbVal, 2),
                abendsPer: ((s1AbVal / s1Total) * 100) || 0,
                abendsPerR: round((s1AbVal / s1Total) * 100) || 0,
                zurNachtVal: round(s1ZUVal, 2),
                zurNachtPer: ((s1ZUVal / s1Total) * 100) || 0,
                zurNachtPerR: round((s1ZUVal / s1Total) * 100) || 0,
            },
            two: {
                morgensVal: round(s2MoVal, 2),
                morgensPer: ((s2MoVal / s2Total) * 100) || 0,
                morgensPerR: round((s2MoVal / s2Total) * 100) || 0,
                mittagsVal: round(s2MiVal, 2),
                mittagsPer: ((s2MiVal / s2Total) * 100) || 0,
                mittagsPerR: round((s2MiVal / s2Total) * 100) || 0,
                abendsVal: round(s2AbVal, 2),
                abendsPer: ((s2AbVal / s2Total) * 100) || 0,
                abendsPerR: round((s2AbVal / s2Total) * 100) || 0,
                zurNachtVal: round(s2ZUVal, 2),
                zurNachtPer: ((s2ZUVal / s2Total) * 100) || 0,
                zurNachtPerR: round((s2ZUVal / s2Total) * 100) || 0,
            },
            three: {
                morgensVal: round(s3MoVal, 2),
                morgensPer: ((s3MoVal / s3Total) * 100) || 0,
                morgensPerR: round((s3MoVal / s3Total) * 100) || 0,
                mittagsVal: round(s3MiVal, 2),
                mittagsPer: ((s3MiVal / s3Total) * 100) || 0,
                mittagsPerR: round((s3MiVal / s3Total) * 100) || 0,
                abendsVal: round(s3AbVal, 2),
                abendsPer: ((s3AbVal / s3Total) * 100) || 0,
                abendsPerR: round((s3AbVal / s3Total) * 100) || 0,
                zurNachtVal: round(s3ZUVal, 2),
                zurNachtPer: ((s3ZUVal / s3Total) * 100) || 0,
                zurNachtPerR: round((s3ZUVal / s3Total) * 100) || 0,
            },
            four: {
                morgensVal: this.morgensVal,
                morgensPer: ((this.morgensVal / this.totalDosierungsVal) * 100) || 0,
                morgensPerR: round((this.morgensVal / this.totalDosierungsVal) * 100) || 0,
                mittagsVal: this.mittagsVal,
                mittagsPer: ((this.mittagsVal / this.totalDosierungsVal) * 100) || 0,
                mittagsPerR: round((this.mittagsVal / this.totalDosierungsVal) * 100) || 0,
                abendsVal: this.abendsVal,
                abendsPer: ((this.abendsVal / this.totalDosierungsVal) * 100) || 0,
                abendsPerR: round((this.abendsVal / this.totalDosierungsVal) * 100) || 0,
                zurNachtVal: this.zurNachtVal,
                zurNachtPer: ((this.zurNachtVal / this.totalDosierungsVal) * 100) || 0,
                zurNachtPerR: round((this.zurNachtVal / this.totalDosierungsVal) * 100) || 0,
            }
        }

        var obj: any = { anwendungen, stufe }
        return obj;
    }

    constructor(private cd: ChangeDetectorRef,
        private sharedService: SharedService) {
    }

    ngOnInit(): void {
        this.bindDataForList();
        this.updateSelectedValues();
    }

    bindDataForList() {
        this.dronabinolSorteList = [];
        this.zieltagesdosisList = [];
        this.startTagesdosisList = [];
        this.anzahlDerTageList = [];

        for (var i = 0; i < this.dronabinolSorteListCalc.length; i++) {
            this.dronabinolSorteList.push({ label: this.dronabinolSorteListCalc[i].label, value: this.dronabinolSorteListCalc[i].label });
        }
        for (var i = 0; i < this.zieltagesdosisListCalc.length; i++) {
            this.zieltagesdosisList.push({ label: this.zieltagesdosisListCalc[i].label, value: this.zieltagesdosisListCalc[i].value });
        }
        for (var i = 0; i < this.startTagesdosisListCalc.length; i++) {
            this.startTagesdosisList.push({ label: this.startTagesdosisListCalc[i].label, value: this.startTagesdosisListCalc[i].value });
        }
        for (var i = 7; i <= this.totalDaysForCalc; i++) {
            this.anzahlDerTageList.push({ label: `${i} Tage`, value: i });
        }
    }

    updateSelectedValues() {
        if (this.titrationsplan) {
            if (this.titrationsplan.dronabinolSorte) {
                this.dronabinolSorte = this.titrationsplan.dronabinolSorte;
            }
            if (this.titrationsplan.zieltagesdosis) {
                this.zieltagesdosis = this.titrationsplan.zieltagesdosis;
            }
            if (this.titrationsplan.startTagesdosis) {
                this.startTagesdosis = this.titrationsplan.startTagesdosis;
            }
            if (this.titrationsplan.anzahlDerTage) {
                this.anzahlDerTage = this.titrationsplan.anzahlDerTage;
            }
            if (this.titrationsplan.morgens) {
                this.morgensVal = this.titrationsplan.morgens;
            }
            if (this.titrationsplan.mittags) {
                this.mittagsVal = this.titrationsplan.mittags;
            }
            if (this.titrationsplan.abends) {
                this.abendsVal = this.titrationsplan.abends;
            }
            if (this.titrationsplan.zurNacht) {
                this.zurNachtVal = this.titrationsplan.zurNacht;
            }
        }
        this.fnCalculateTablesAndGraphs();
    }

    inputChange() {
        this.fnCalculateTablesAndGraphs();
    }

    sliderUserChange() {
        this.selectedPresetButton = null;
        this.fnCalculateTablesAndGraphs();
    }

    sliderValueChange() {

    }

    onSelectPresetButton(button) {
        this.selectedPresetButton = button;
        switch (button.id) {
            case 1:
                this.morgensVal = 5;
                this.mittagsVal = 5;
                this.abendsVal = 5;
                this.zurNachtVal = 5;
                break;
            case 2:
                this.morgensVal = 2;
                this.mittagsVal = 2;
                this.abendsVal = 4;
                this.zurNachtVal = 8;
                break;
            case 3:
                this.morgensVal = 8;
                this.mittagsVal = 4;
                this.abendsVal = 4;
                this.zurNachtVal = 4;
                break;
            case 4:
                this.morgensVal = 4;
                this.mittagsVal = 8;
                this.abendsVal = 4;
                this.zurNachtVal = 4;
                break;
        }
        this.fnCalculateTablesAndGraphs();
    }

    onShowHide(type) {
        if (type === 'Tropfen') {
            this.showTropfen = !this.showTropfen;
        }
        if (type === 'Hube') {
            this.showHube = !this.showHube;
        }
        this.cd.detectChanges();
        this.fnCalculateTablesAndGraphs();
    }

    toggleWeitereInfo() {
        this.showWeitereInfo = !this.showWeitereInfo;
    }

    fnPrintData() {
        this.sharedService.printHTMLData(this.printableHTML, {
            headCss: true
        });
    }

    getRezeptHube() {
        return `${this.dronabinolSorteType} ${formatNumber(roundUp(((this.zieltagesdosisVal * 30) + 5) / 100) * 100 / this.dronabinolSorteVal, DE)} mL mit ${formatNumber(this.dronabinolSorteVal, DE)} mg THC/mL (${formatNumber(roundUp(((this.zieltagesdosisVal * 30) + 5) / 100) * 100, DE)} mg THC), oral einnehmen`;
    }

    getGesamtverschreibungsmengeTropfen() {
        return formatNumber(round(this.getTotalTagesdosisMilligrammTrofen(1) / this.dronabinolSorteVal, 1), DE);
    }

    getGesamtverschreibungsmengeHube() {
        return `${formatNumber(roundUp(((this.zieltagesdosisVal * 30) + 15) / 100) * 100 / this.dronabinolSorteVal, DE)} mL ${this.dronabinolSorteType} mit ${formatNumber(this.dronabinolSorteVal, DE)} mg THC/mL (${formatNumber(roundUp(((this.zieltagesdosisVal * 30) + 15) / 100) * 100, DE)} mg THC)`
    }

    getTitrationsPlanEntSprichtHube() {
        return formatNumber(round(this.getTotalTagesdosisErrechnetHube(1) / this.dronabinolSorteVal, 1), DE);
    }

    getTotalTagesdosisMilligramm(fraction = 0) {
        var total = 0;
        this.milligrammCalculation.forEach(item => {
            total += item.tagesdosisMilligramm;
        })
        return round(total, fraction);
    }


    getTotalTagesdosisMilligrammTrofen(fraction = 0) {
        var total = 0;
        this.tropfenCalculation.forEach(item => {
            total += item.tagesdosisMilligramm;
        })
        return round(total, fraction);
    }


    getTotalTagesdosisMilligrammHube(fraction = 0) {
        var total = 0;
        this.hubeCalculation.forEach(item => {
            total += item.tagesdosisMilligramm;
        })
        return round(total, fraction);
    }

    getTotalTagesdosisErrechnetHube(fraction = 0) {
        var total = 0;
        this.hubeCalculation.forEach(item => {
            total += item.tagesdosisErrechnet;
        })
        return round(total, fraction);
    }

    fnCalculateTablesAndGraphs() {
        this.titrationsplan = {
            dronabinolSorte: this.dronabinolSorte,
            zieltagesdosis: this.zieltagesdosis,
            startTagesdosis: this.startTagesdosis,
            anzahlDerTage: this.anzahlDerTage,
            morgens: this.morgensVal,
            mittags: this.mittagsVal,
            abends: this.abendsVal,
            zurNacht: this.zurNachtVal
        }
        this.onSelectValues.emit(this.titrationsplan);

        if (this.showTropfen || this.showHube) {
            this.fnCalculateMilligram();
            this.fnCalculateTropfen();
            this.fnCalculateHube();
            this.fnCalculateTableData();
            this.fnGenerateChart();
        }
    }

    fnCalculateMilligram() {
        this.milligrammCalculation = [];
        for (var i = 1; i <= this.totalDaysForCalc; i++) {
            var morgens = 0;
            var mittags = 0;
            var abends = 0;
            var zurnacht = 0;
            var tagesdosisMilligramm = 0;

            var stufeIntervall = 0;
            var tagesdosisErrechnet = 0;
            var einzeldosisErrechnet = 0;

            if (i < (this.anzahlDerTageVal + 1)) {
                if (i < this.StufeIntervallOneAnzahlTage.calc + 1) {
                    stufeIntervall = this.StufeIntervallOneAnzahlTage.key;
                } else if (i < this.StufeIntervallTwoAnzahlTage.calc + 1) {
                    stufeIntervall = this.StufeIntervallTwoAnzahlTage.key;
                } else if (i < this.StufeIntervallThreeAnzahlTage.calc + 1) {
                    stufeIntervall = this.StufeIntervallThreeAnzahlTage.key;
                } else {
                    stufeIntervall = this.StufeIntervallFourAnzahlTage.key;
                }
                tagesdosisErrechnet = round(((i - 1) * ((this.zieltagesdosisVal - this.startTagesdosisVal) / this.anzahlDerTageVal) + this.startTagesdosisVal), 1);
                einzeldosisErrechnet = round((tagesdosisErrechnet / stufeIntervall), 1);

                if (stufeIntervall > 1) {
                    morgens = einzeldosisErrechnet;
                }
                if (stufeIntervall > 2) {
                    mittags = einzeldosisErrechnet;
                }
                abends = einzeldosisErrechnet;
                if (stufeIntervall > 3) {
                    zurnacht = einzeldosisErrechnet;
                }
                tagesdosisMilligramm = round((morgens + mittags + abends + zurnacht), 1);
            } else if (this.milligrammCalculation.length) {
                morgens = this.milligrammCalculation[i - 2].morgens;
                mittags = this.milligrammCalculation[i - 2].mittags;
                abends = this.milligrammCalculation[i - 2].abends;
                zurnacht = this.milligrammCalculation[i - 2].zurnacht;
                tagesdosisMilligramm = round((morgens + mittags + abends + zurnacht), 1);
            }

            this.milligrammCalculation.push({ morgens, mittags, abends, zurnacht, tagesdosisMilligramm, stufeIntervall, tagesdosisErrechnet, einzeldosisErrechnet });
        }
    }

    fnCalculateTropfen() {
        this.tropfenCalculation = [];
        for (var i = 1; i <= this.totalDaysForCalc; i++) {
            var morgens = 0;
            var mittags = 0;
            var abends = 0;
            var zurnacht = 0;
            var tagesdosisTropfen = 0;

            var stufeIntervall = 0;
            var tagesdosisErrechnet = 0;
            var morgensEinzeldosisErrechnet = 0;
            var mittagsEinzeldosisErrechnet = 0;
            var abendsEinzeldosisErrechnet = 0;
            var zurNachtEinzeldosisErrechnet = 0;

            var tagesdosisMilligramm = 0;

            if (i < this.anzahlDerTageVal + 1) {
                if (i < this.StufeIntervallOneAnzahlTage.calc + 1) {
                    stufeIntervall = this.StufeIntervallOneAnzahlTage.key;
                } else if (i < this.StufeIntervallTwoAnzahlTage.calc + 1) {
                    stufeIntervall = this.StufeIntervallTwoAnzahlTage.key;
                } else if (i < this.StufeIntervallThreeAnzahlTage.calc + 1) {
                    stufeIntervall = this.StufeIntervallThreeAnzahlTage.key;
                } else {
                    stufeIntervall = this.StufeIntervallFourAnzahlTage.key;
                }
                tagesdosisErrechnet = round(((i - 1) * ((this.zieltagesdosisVal - this.startTagesdosisVal) / this.anzahlDerTageVal) + this.startTagesdosisVal), 1);
                morgensEinzeldosisErrechnet = round((tagesdosisErrechnet / stufeIntervall), 1);
                mittagsEinzeldosisErrechnet = round((tagesdosisErrechnet / stufeIntervall), 1);
                abendsEinzeldosisErrechnet = round((tagesdosisErrechnet / stufeIntervall), 1);
                zurNachtEinzeldosisErrechnet = round((tagesdosisErrechnet / stufeIntervall), 1);

                if (stufeIntervall > 1) {
                    morgens = round(morgensEinzeldosisErrechnet / this.thcMGTropfen);
                }
                if (stufeIntervall > 2) {
                    mittags = round(mittagsEinzeldosisErrechnet / this.thcMGTropfen);
                }
                abends = round(abendsEinzeldosisErrechnet / this.thcMGTropfen);
                if (stufeIntervall > 3) {
                    zurnacht = round(zurNachtEinzeldosisErrechnet / this.thcMGTropfen);
                }

                tagesdosisTropfen = round((morgens + mittags + abends + zurnacht), 1);
                tagesdosisMilligramm = round(tagesdosisTropfen * this.thcMGTropfen, 1);
            } else if (this.tropfenCalculation.length) {
                morgens = this.tropfenCalculation[i - 2].morgens;
                mittags = this.tropfenCalculation[i - 2].mittags;
                abends = this.tropfenCalculation[i - 2].abends;
                zurnacht = this.tropfenCalculation[i - 2].zurnacht;
                tagesdosisTropfen = round((morgens + mittags + abends + zurnacht), 1);
                tagesdosisMilligramm = round(tagesdosisTropfen * this.thcMGTropfen, 1);
            }
            this.tropfenCalculation.push({ morgens, mittags, abends, zurnacht, tagesdosisTropfen, stufeIntervall, tagesdosisErrechnet, morgensEinzeldosisErrechnet, mittagsEinzeldosisErrechnet, abendsEinzeldosisErrechnet, zurNachtEinzeldosisErrechnet, tagesdosisMilligramm });
        }
    }

    fnCalculateHube() {
        this.hubeCalculation = [];
        for (var i = 1; i <= this.totalDaysForCalc; i++) {
            var morgens = 0;
            var mittags = 0;
            var abends = 0;
            var zurnacht = 0;
            var tagesdosisHube = 0;

            var stufeIntervall = 0;
            var tagesdosisErrechnet = 0;
            var morgensEinzeldosisErrechnet = 0;
            var mittagsEinzeldosisErrechnet = 0;
            var abendsEinzeldosisErrechnet = 0;
            var zurNachtEinzeldosisErrechnet = 0;

            var tagesdosisMilligramm = 0;
            var tagesdosisMilligrammR = 0;

            if (i < this.anzahlDerTageVal + 2) {
                tagesdosisErrechnet = round(((i - 1) * ((this.zieltagesdosisVal - this.startTagesdosisVal) / this.anzahlDerTageVal) + this.startTagesdosisVal), 1);

                if (i < this.anzahlDerTageVal + 1) {
                    if (i < this.StufeIntervallOneAnzahlTage.calc + 1) {
                        stufeIntervall = this.StufeIntervallOneAnzahlTage.key;
                    } else if (i < this.StufeIntervallTwoAnzahlTage.calc + 1) {
                        stufeIntervall = this.StufeIntervallTwoAnzahlTage.key;
                    } else if (i < this.StufeIntervallThreeAnzahlTage.calc + 1) {
                        stufeIntervall = this.StufeIntervallThreeAnzahlTage.key;
                    } else {
                        stufeIntervall = this.StufeIntervallFourAnzahlTage.key;
                    }
                }

                if (stufeIntervall == 1) {
                    morgensEinzeldosisErrechnet = round(tagesdosisErrechnet * this.zeitlicherSchwerpunkt.stufe.one.morgensPer / 100, 1);
                    mittagsEinzeldosisErrechnet = round(tagesdosisErrechnet * this.zeitlicherSchwerpunkt.stufe.one.mittagsPer / 100, 1);
                    abendsEinzeldosisErrechnet = round(tagesdosisErrechnet * this.zeitlicherSchwerpunkt.stufe.one.abendsPer / 100, 1);
                    zurNachtEinzeldosisErrechnet = round(tagesdosisErrechnet * this.zeitlicherSchwerpunkt.stufe.one.zurNachtPer / 100, 1);
                } else if (stufeIntervall == 2) {
                    morgensEinzeldosisErrechnet = round(tagesdosisErrechnet * this.zeitlicherSchwerpunkt.stufe.two.morgensPer / 100, 1);
                    mittagsEinzeldosisErrechnet = round(tagesdosisErrechnet * this.zeitlicherSchwerpunkt.stufe.two.mittagsPer / 100, 1);
                    abendsEinzeldosisErrechnet = round(tagesdosisErrechnet * this.zeitlicherSchwerpunkt.stufe.two.abendsPer / 100, 1);
                    zurNachtEinzeldosisErrechnet = round(tagesdosisErrechnet * this.zeitlicherSchwerpunkt.stufe.two.zurNachtPer / 100, 1);
                } else if (stufeIntervall == 3) {
                    morgensEinzeldosisErrechnet = round(tagesdosisErrechnet * this.zeitlicherSchwerpunkt.stufe.three.morgensPer / 100, 1);
                    mittagsEinzeldosisErrechnet = round(tagesdosisErrechnet * this.zeitlicherSchwerpunkt.stufe.three.mittagsPer / 100, 1);
                    abendsEinzeldosisErrechnet = round(tagesdosisErrechnet * this.zeitlicherSchwerpunkt.stufe.three.abendsPer / 100, 1);
                    zurNachtEinzeldosisErrechnet = round(tagesdosisErrechnet * this.zeitlicherSchwerpunkt.stufe.three.zurNachtPer / 100, 1);
                } else {
                    morgensEinzeldosisErrechnet = round(tagesdosisErrechnet * this.zeitlicherSchwerpunkt.stufe.four.morgensPer / 100, 1);
                    mittagsEinzeldosisErrechnet = round(tagesdosisErrechnet * this.zeitlicherSchwerpunkt.stufe.four.mittagsPer / 100, 1);
                    abendsEinzeldosisErrechnet = round(tagesdosisErrechnet * this.zeitlicherSchwerpunkt.stufe.four.abendsPer / 100, 1);
                    zurNachtEinzeldosisErrechnet = round(tagesdosisErrechnet * this.zeitlicherSchwerpunkt.stufe.four.zurNachtPer / 100, 1);
                }

            } else {
                tagesdosisErrechnet = this.hubeCalculation[i - 2].tagesdosisErrechnet;
            }

            if (i < this.anzahlDerTageVal + 1) {
                if (morgensEinzeldosisErrechnet > 0) {
                    morgens = round(morgensEinzeldosisErrechnet / this.thcMGHub);
                }
                if (mittagsEinzeldosisErrechnet > 0) {
                    mittags = round(mittagsEinzeldosisErrechnet / this.thcMGHub);
                }
                if (abendsEinzeldosisErrechnet > 0) {
                    abends = round(abendsEinzeldosisErrechnet / this.thcMGHub);
                }
                if (zurNachtEinzeldosisErrechnet > 0) {
                    zurnacht = round(zurNachtEinzeldosisErrechnet / this.thcMGHub);
                }

            } else if (this.hubeCalculation.length) {
                morgens = this.hubeCalculation[i - 2].morgens;
                mittags = this.hubeCalculation[i - 2].mittags;
                abends = this.hubeCalculation[i - 2].abends;
                zurnacht = this.hubeCalculation[i - 2].zurnacht;

                if (i >= this.anzahlDerTageVal + 2) {
                    morgensEinzeldosisErrechnet = this.hubeCalculation[i - 2].morgensEinzeldosisErrechnet;
                    mittagsEinzeldosisErrechnet = this.hubeCalculation[i - 2].mittagsEinzeldosisErrechnet;
                    abendsEinzeldosisErrechnet = this.hubeCalculation[i - 2].abendsEinzeldosisErrechnet;
                    zurNachtEinzeldosisErrechnet = this.hubeCalculation[i - 2].zurNachtEinzeldosisErrechnet;
                }

            }

            tagesdosisHube = round((morgens + mittags + abends + zurnacht), 1);
            tagesdosisMilligramm = tagesdosisHube * this.thcMGHub;
            tagesdosisMilligrammR = round(tagesdosisMilligramm, 1);

            this.hubeCalculation.push({ morgens, mittags, abends, zurnacht, tagesdosisHube, stufeIntervall, tagesdosisErrechnet, morgensEinzeldosisErrechnet, mittagsEinzeldosisErrechnet, abendsEinzeldosisErrechnet, zurNachtEinzeldosisErrechnet, tagesdosisMilligramm, tagesdosisMilligrammR });
        }
    }

    fnCalculateTableData() {
        if (this.showTropfen) {
            this.fnCalculateTropfenformData();
        }
        if (this.showHube) {
            this.fnCalculateHubdosierungData();
        }
    }

    fnCalculateTropfenformData() {
        this.tropfenformData = [];
        for (var i = 0; i < this.milligrammCalculation.length; i++) {
            var miliObj = this.milligrammCalculation[i];
            var trofenObj = this.tropfenCalculation[i];
            var tag = i + 1;
            var morgens = { text: "", value: 0 };
            var mittags = { text: "", value: 0 };
            var abends = { text: "", value: 0 };
            var zurnacht = { text: "", value: 0 };
            var tagesdosis = { text: "", value: 0 };
            if (miliObj.morgens > 0) {
                morgens.text = `${trofenObj.morgens} Tropfen\n(${round(trofenObj.morgens * this.thcMGTropfen, 1)} mg/${round(trofenObj.morgens * this.oneTropfen, 2)} mL)`;
                morgens.value = trofenObj.morgens;
            }
            if (miliObj.mittags > 0) {
                mittags.text = `${trofenObj.mittags} Tropfen\n(${round(trofenObj.mittags * this.thcMGTropfen, 1)} mg/${round(trofenObj.mittags * this.oneTropfen, 2)} mL)`;
                mittags.value = trofenObj.mittags;
            }
            if (miliObj.abends > 0) {
                abends.text = `${trofenObj.abends} Tropfen\n(${round(trofenObj.abends * this.thcMGTropfen, 1)} mg/${round(trofenObj.abends * this.oneTropfen, 2)} mL)`;
                abends.value = trofenObj.abends;
            }
            if (miliObj.zurnacht > 0) {
                zurnacht.text = `${trofenObj.zurnacht} Tropfen\n(${round(trofenObj.zurnacht * this.thcMGTropfen, 1)} mg/${round(trofenObj.zurnacht * this.oneTropfen, 2)} mL)`;
                zurnacht.value = trofenObj.zurnacht;
            }
            if (trofenObj.tagesdosisMilligramm > 0) {
                tagesdosis.text = `(${round(trofenObj.tagesdosisMilligramm, 1)} mg)`;
                tagesdosis.value = round(trofenObj.tagesdosisMilligramm, 1);
            }
            this.tropfenformData.push({ tag, morgens, mittags, abends, zurnacht, tagesdosis });
        }
    }

    fnCalculateHubdosierungData() {
        this.hubdosierungData = [];
        for (var i = 0; i < this.hubeCalculation.length; i++) {
            var hubeObj = this.hubeCalculation[i];
            var tag = i + 1;
            var morgens = { text: "", value: 0 };
            var mittags = { text: "", value: 0 };
            var abends = { text: "", value: 0 };
            var zurnacht = { text: "", value: 0 };
            var tagesdosis = { text: "", value: 0 };
            if (hubeObj.morgens > 0) {
                morgens.text = `${formatNumber(round(hubeObj.morgensEinzeldosisErrechnet / this.dronabinolSorteVal, 2), DE)} mL\n(${formatNumber(round(hubeObj.morgensEinzeldosisErrechnet, 1), DE)} mg/${formatNumber(hubeObj.morgens, DE)} Hübe)`;
                morgens.value = round(hubeObj.morgensEinzeldosisErrechnet / this.dronabinolSorteVal, 2);
            }
            if (hubeObj.mittags > 0) {
                mittags.text = `${formatNumber(round(hubeObj.mittagsEinzeldosisErrechnet / this.dronabinolSorteVal, 2), DE)} mL\n(${formatNumber(round(hubeObj.mittagsEinzeldosisErrechnet, 1), DE)} mg/${formatNumber(hubeObj.mittags, DE)} Hübe)`;
                mittags.value = round(hubeObj.mittagsEinzeldosisErrechnet / this.dronabinolSorteVal, 2);
            }
            if (hubeObj.abends > 0) {
                abends.text = `${formatNumber(round(hubeObj.abendsEinzeldosisErrechnet / this.dronabinolSorteVal, 2), DE)} mL\n(${formatNumber(round(hubeObj.abendsEinzeldosisErrechnet, 1), DE)} mg/${formatNumber(hubeObj.abends, DE)} Hübe)`;
                abends.value = round(hubeObj.abendsEinzeldosisErrechnet / this.dronabinolSorteVal, 2);
            }
            if (hubeObj.zurnacht > 0) {
                zurnacht.text = `${formatNumber(round(hubeObj.zurNachtEinzeldosisErrechnet / this.dronabinolSorteVal, 2), DE)} mL\n(${formatNumber(round(hubeObj.zurNachtEinzeldosisErrechnet, 1), DE)} mg/${formatNumber(hubeObj.zurnacht, DE)} Hübe)`;
                zurnacht.value = round(hubeObj.zurNachtEinzeldosisErrechnet / this.dronabinolSorteVal, 2);
            }
            if (hubeObj.tagesdosisErrechnet > 0) {
                tagesdosis.text = `(${formatNumber(round(hubeObj.tagesdosisErrechnet, 1), DE)} mg)`;
                tagesdosis.value = round(hubeObj.tagesdosisErrechnet / this.dronabinolSorteVal, 2);
            }
            this.hubdosierungData.push({ tag, morgens, mittags, abends, zurnacht, tagesdosis });
        }
    }

    chartTimer: any;
    fnGenerateChart() {
        clearTimeout(this.chartTimer);
        this.chartTimer = setTimeout(() => {
            if (this.showTropfen) {
                d3.select("#tropfenformChart").selectAll("svg").remove();
                this.fnGenerateTropfenChart();
            }
            if (this.showHube) {
                d3.select("#hubdosierungChart").selectAll("svg").remove();
                this.fnGenerateHubeChart();
            }
        })
    }

    fnGenerateTropfenChart() {
        var elmId = "tropfenformChart";
        var data = [];
        this.tropfenformData.forEach(item => {
            data.push({
                tag: item.tag,
                morgens: item.morgens.value,
                mittags: item.mittags.value,
                abends: item.abends.value,
                zurnacht: item.zurnacht.value
            })
        })
        this.generateChartDiagram(elmId, data, "Titrationsplan Tropfen Cannabisextrakt", "Tropfen");

    }

    fnGenerateHubeChart() {
        var elmId = "hubdosierungChart";
        var data = [];
        this.hubdosierungData.forEach(item => {
            var obj = {
                tag: item.tag,
                morgens: item.morgens.value,
                mittags: item.mittags.value,
                abends: item.abends.value,
                zurnacht: item.zurnacht.value
            }
            data.push(obj);
        })
        this.generateChartDiagram(elmId, data, "TITRATIONSPLAN", "Milliliter");
    }

    generateChartDiagram(elmId, data, title, yText) {

        var tags = data.map(a => a.tag);
        var groups = ["morgens", "mittags", "abends", "zurnacht"];
        var labels = [
            { key: 'morgens', label: 'morgens' },
            { key: 'mittags', label: 'mittags' },
            { key: 'abends', label: 'abends' },
            { key: 'zurnacht', label: 'zur Nacht' }
        ];
        var colorRange = ['#4a86e8', '#f6b81b', '#cc4125', '#351c75'];
        const stackedData = d3.stack().keys(groups)(data);

        // set the dimensions and margins of the graph
        var elmWidth = document.getElementById(elmId).clientWidth;
        var elmHeight = 420;

        var maxTotal = 0;
        data.forEach(a => {
            var total = 0;
            groups.forEach(g => {
                total += a[g];
            })
            if (maxTotal < total) {
                maxTotal = total;
            }
        })

        //var newHeight = maxTotal * 5;
        //if (elmHeight < newHeight) {
        //    elmHeight = newHeight;
        //}

        var margin = { top: 40, right: 10, bottom: 80, left: 50 },
            width = elmWidth - margin.left - margin.right,
            height = elmHeight - margin.top - margin.bottom;

        // append the svg object to the body of the page
        var svg = d3.select(`#${elmId}`)
            .append("svg")
            .attr("width", width + margin.left + margin.right)
            .attr("height", height + margin.top + margin.bottom)
            .append("g")
            .attr("transform",
                "translate(" + margin.left + "," + margin.top + ")");

        // Add X axis
        var x = d3.scaleBand()
            .domain(tags)
            .range([0, width])
            .padding(0.2)

        svg.append("g")
            .attr("transform", "translate(0," + height + ")")
            .call(d3.axisBottom(x).tickSizeOuter(0));

        // Add Y axis
        var y = d3.scaleLinear()
            .domain([0, roundUp(maxTotal, 1)])
            .range([height, 0]);

        svg.append("g")
            .call(
                d3.axisLeft(y)
                    .tickFormat((value, i) => {
                        return `${formatNumber(Number(value), DE)}`
                    })
            );

        // color palette = one color per group
        var color = d3.scaleOrdinal()
            .domain(groups)
            .range(colorRange)

        // now add titles to the axes
        svg.append('g')
            .append("text")
            .style("font-size", "18px")
            .attr("transform", "translate(-40,-25)")  // top left corner
            .attr("font-weight", "500")
            .text(title);

        svg.append('g')
            .append("text")
            .style("font-size", "14px")
            .attr("text-anchor", "middle")  // this makes it easy to centre the text as the transform is applied to the anchor
            .attr("transform", "translate(15," + (height + 35) + ")")  // centre below axis
            .text("Tag");

        svg.append('g')
            .append("text")
            .style("font-size", "14px")
            .attr("text-anchor", "middle")  // this makes it easy to centre the text as the transform is applied to the anchor
            .attr("transform", "translate(" + -35 + "," + (height - 20) + ")rotate(-90)")  // text is drawn off the screen top left, move down and out and rotate
            .text(yText);


        var legend = svg.append("g")
            .attr("class", "svg-legend")
            .attr("font-size", 12)
            .attr("transform", "translate(" + ((elmWidth / 2) - 145 - 25) + "," + (height + 50) + ")")
            .selectAll("g")
            .data(groups.slice())
            .enter().append("g")
            .attr("transform", function (d, i) {
                return "translate(" + i * 75 + ",0)";
            });

        legend.append("rect")
            .attr("y", 0)
            .attr("width", 12)
            .attr("height", 12)
            .attr("fill", function (d: any) { return color(d).toString(); });

        legend.append("text")
            .attr("x", 15)
            .attr("y", 6)
            .attr("dy", "0.35em")
            .text(function (d) {
                return labels.find(a => a.key == d).label;
            });


        // Show the bars
        svg.append("g")
            .selectAll("g")
            // Enter in the stack data = loop key per key = group per group
            .data(stackedData)
            .enter().append("g")
            .attr("fill", function (d) { return color(d.key).toString(); })
            .selectAll("rect")
            // enter a second time = loop groups per groups to add all rectangles
            .data(function (d: any) { return d; })
            .enter().append("rect")
            .attr("x", function (d: any) { return x(d.data.tag); })
            .attr("y", function (d: any) { return y(d[1]); })
            .attr("height", function (d: any) { return y(d[0]) - y(d[1]); })
            .attr("width", x.bandwidth())

        svg.append("g")
            .selectAll("g")
            // Enter in the stack data = loop key per key = group per group
            .data(stackedData)
            .enter().append("g")
            .selectAll("text")
            // enter a second time = loop groups per groups to add all rectangles
            .data(function (d: any) { return d; })
            .enter().append("text")
            .attr("x", function (d: any) { return x(d.data.tag); })
            .attr("y", function (d: any) { return y(d[1]); })
            .attr("dx", x.bandwidth() / 2)
            .attr("dy", function (d: any) { return (y(d[0]) - y(d[1])) / 2; })
            .attr("font-size", 10)
            .attr("text-anchor", "middle")
            .attr("fill", "#ffffff")
            .attr("pointer-events", "none")
            .text(function (d) {
                var diff = d[1] - d[0];
                return diff > 0 ? formatNumber(round(diff, 2), DE) : "";
            })

    }

    async fnUpdatePopupContent() {
        this.fnGenerateChart();
    }

}
